import { buildProps } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'
import type TimelineItem from './timeline-item.vue'
import type Timeline from './timeline.vue'

// props
export const timelineProps = buildProps({
  // 是否开启幽灵节点
  pending: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export const timelineItemProps = buildProps({
  dotIcon: {
    type: String,
    default: '',
  },
} as const)

export type TimelineProps = ExtractPropTypes<typeof timelineProps>
export type TimelineItemProps = ExtractPropTypes<typeof timelineItemProps>

// instance
export type TimelineInstance = InstanceType<typeof Timeline>
export type TimelineItemInstance = InstanceType<typeof TimelineItem>
